import { mount } from "@vue/test-utils";
import DateField from "@/components/core/DateField";

describe("DateField component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = mount(DateField);
  });

  it("Renders del component DateField", () => {
    expect(wrapper).toBeDefined();
  });

  it("should return input value", async () => {
    const input = wrapper.find("input");
    wrapper.vm.checked = true;
    await input.setValue("14/06/1986");

    expect(input.element.value).toBe("14/06/1986");
    expect(wrapper.vm.validationError).toBeNull();
  });

  it("should return onInput value", async () => {
    wrapper.vm.checked = true;

    await wrapper.vm.onInput("14/06/1986");

    expect(wrapper.vm.validationError).toBeNull();
  });

  it("should return wrong input value", async () => {
    wrapper.vm.checked = true;
    await wrapper.vm.isValid("ABC");

    expect(wrapper.vm.validationError).toBe("La fecha no es válida");
  });
});
